import gql from 'graphql-tag';

const GET_WORKLOG_TIMER_ENTRIES = gql`
  query fetchWorklogTimerEntries(
    $timeEntriesInput: GetWorklogTimerEntriesInput!
  ) {
    fetchWorklogTimerEntries(input: $timeEntriesInput) {
      entries {
        billable
        serviceItem {
          itemId
          name
        }
        serviceCatalogItem {
          itemId
          name
        }
        notes
        state
        timespent
        ticket {
          ticketId
        }
        project {
          projectId
        }
        task {
          taskId
          displayId
          title
        }
        createdTime
        module
      }
    }
  }
`;

const GET_GLOBAL_TIMER_ENTRIES = gql`
  query fetchWorklogTimerEntries(
    $worklogTimerInput: GetWorklogTimerEntriesInput!
    $isItProduct: Boolean!
  ) {
    fetchWorklogTimerEntries(input: $worklogTimerInput) {
      entries {
        timerId
        billable
        serviceItem {
          itemId
          name
        }
        serviceCatalogItem {
          itemId
          name
        }
        notes
        state
        type
        timespent
        workItem {
          workId
          displayId
          subject
          module
          ticket @skip(if: $isItProduct) {
            contractTicketMapping {
              contractId
              contract {
                contractId
              }
              inUse
            }
          }
          project @skip(if: $isItProduct) {
            contract {
              contractId
            }
          }
          client {
            name
            accountId
          }
          site {
            id
            name
          }
        }
        running
        createdTime
        module
        technician {
          userId
          firstName
          lastName
          email
          name
        }
        task {
          taskId
          displayId
          title
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_ALL_TIMER_ENTRIES = gql`
  query fetchWorklogTimerEntries(
    $worklogTimerInput: GetWorklogTimerEntriesInput!
    $isItProduct: Boolean!
  ) {
    fetchWorklogTimerEntries(input: $worklogTimerInput) {
      entries {
        timerId
        billable
        serviceItem {
          itemId
          name
        }
        serviceCatalogItem {
          itemId
          name
        }
        notes
        state
        type
        timespent
        workItem {
          ticket @skip(if: $isItProduct) {
            contractTicketMapping {
              contractId
              contract {
                contractId
              }
              inUse
            }
          }
          project @skip(if: $isItProduct) {
            contract {
              contractId
            }
          }
          workId
          displayId
          subject
          module
          client {
            name
            accountId
          }
          site {
            id
            name
          }
        }
        task {
          taskId
          displayId
          title
        }
        running
        createdTime
        module
        segments {
          segmentId
          startTime
          endTime
          timespent
          afterHours
        }
        technician {
          userId
          firstName
          lastName
          email
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_ALL_TIMER_ENTRIES_FOR_TABLE = gql`
  query fetchWorklogTimerEntries(
    $worklogTimerInput: GetWorklogTimerEntriesInput!
  ) {
    fetchWorklogTimerEntries(input: $worklogTimerInput) {
      entries {
        timerId
        billable
        serviceItem {
          itemId
          name
        }
        serviceCatalogItem {
          itemId
          name
        }
        notes
        state
        type
        timespent
        workItem {
          # ticket @skip(if: $isItProduct) {
          #   contractTicketMapping {
          #     contractId
          #     contract {
          #       contractId
          #     }
          #     inUse
          #   }
          # }
          # project @skip(if: $isItProduct) {
          #   contract {
          #     contractId
          #   }
          # }
          workId
          displayId
          subject
          module
          client {
            name
            accountId
          }
          site {
            id
            name
          }
        }
        running
        createdTime
        module
        technician {
          userId
          firstName
          lastName
          email
          name
        }
        task {
          taskId
          title
          workItem {
            workId
            module
            displayId
            subject
          }
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_WORKLOG_ENTRIES = gql`
  query fetchWorklogEntries($worklogInput: GetWorklogEntriesInput!) {
    fetchWorklogEntries(input: $worklogInput) {
      entries {
        itemId
        status
        serviceItem {
          itemId
          name
          salesTaxEnabled
          salesTax {
            taxId
            name
            rates {
              rateId
              name
              rateValue
            }
          }
        }
        serviceCatalogItem {
          itemId
          name
        }
        qty
        revisedQuantity
        worklogTimerType
        billable
        afterHours
        unitPrice
        billDateTime
        technician {
          userId
          name
        }
        notes
        module
        workItem {
          workId
          module
          displayId
          subject
          client {
            name
            accountId
          }
          site {
            id
            name
          }
          client {
            accountId
            name
          }
        }
        segments {
          segmentId
          timespent
          event {
            eventId
            startTime
            endTime
          }
        }
        task {
          taskId
          title
          workItem {
            workId
            module
            displayId
            subject
          }
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const GET_WORKLOG_ENTRIES_FOR_TABLE = gql`
  query fetchWorklogEntries($worklogInput: GetWorklogEntriesInput!) {
    fetchWorklogEntries(input: $worklogInput) {
      entries {
        itemId
        status
        serviceItem {
          itemId
          name
          salesTaxEnabled
          salesTax {
            taxId
            name
            rates {
              rateId
              name
              rateValue
            }
          }
        }
        serviceCatalogItem {
          itemId
          name
        }

        billable
        afterHours
        qty
        revisedQuantity
        worklogTimerType
        unitPrice
        billDateTime
        technician {
          userId
          name
        }
        notes
        module
        workItem {
          workId
          module
          displayId
          subject
          client {
            name
            accountId
          }
          site {
            id
            name
          }
          client {
            accountId
            name
          }
        }
        task {
          taskId
          title
          workItem {
            workId
            module
            displayId
            subject
          }
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_BLOCKITEM_CONSUMPTION_INFO = gql`
  query getBlockItemConsumptionInfo($input: GetBlockItemConsumptionInfoInput!) {
    getBlockItemConsumptionInfo(input: $input) {
      remainingBlockHours
      blockHoursUnderAudit
      remainingBlockMoney
      blockMoneyUnderAudit
    }
  }
`;

export const GET_BLOCKITEM_INFO = gql`
  query getBlockItemInfo($input: GetBlockItemInfoInput!) {
    getBlockItemInfo(input: $input) {
      remainingBlockHours
      blockHoursUnderAudit
      remainingBlockMoney
      blockMoneyUnderAudit
    }
  }
`;

const FETCH_WORKLOG_ENTRIES = gql`
  query fetchWorklogEntries($input: GetWorklogEntriesInput!) {
    fetchWorklogEntries(input: $input) {
      entries {
        itemId
        status
        serviceItem {
          itemId
          name
          salesTaxEnabled
          salesTax {
            taxId
            name
            rates {
              rateId
              name
              rateValue
            }
          }
        }
        serviceCatalogItem {
          itemId
          name
        }
        billable
        afterHours
        qty
        revisedQuantity
        worklogTimerType
        unitPrice
        billDateTime
        notes
        module
        technician {
          name
        }
        workItem {
          workId
          module
          displayId
          subject
          client {
            name
            accountId
          }
          site {
            id
            name
          }
          client {
            accountId
            name
          }
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export {
  GET_WORKLOG_TIMER_ENTRIES,
  GET_WORKLOG_ENTRIES,
  GET_ALL_TIMER_ENTRIES,
  GET_BLOCKITEM_CONSUMPTION_INFO,
  GET_ALL_TIMER_ENTRIES_FOR_TABLE,
  GET_WORKLOG_ENTRIES_FOR_TABLE,
  FETCH_WORKLOG_ENTRIES,
  GET_GLOBAL_TIMER_ENTRIES
};
